/**
 * CART FEATURE FLAGS
 * Controls which cart system version to use
 */

window.CART_FEATURE_FLAGS = {
  // Main feature flag - V2 is now DEFAULT
  USE_CART_V2: localStorage.getItem('cart-v2-disabled') !== 'true' && 
               !window.location.search.includes('cart-v2=false'),
  
  // Granular flags for testing
  USE_NEW_DRAWER: true,
  USE_NEW_API: true,
  USE_NEW_CORE: true,
  OPTIMISTIC_PLACEHOLDER: true,
  
  // Debug flags
  ENABLE_CART_DEBUG: window.location.hostname === 'localhost' || window.location.hostname.includes('dev'),
  ENABLE_PERFORMANCE_LOGGING: true
};

// Helper function to check flags
window.isCartV2Enabled = () => window.CART_FEATURE_FLAGS.USE_CART_V2;

console.log('🚩 Cart Feature Flags loaded:', window.CART_FEATURE_FLAGS);
console.log('🎯 Cart V2 is now the DEFAULT system');
console.log('💡 To disable V2: Add ?cart-v2=false to URL or run localStorage.setItem("cart-v2-disabled", "true")');